import { render, staticRenderFns } from "./qlk-media.vue?vue&type=template&id=2c00aab7"
import script from "./qlk-media.vue?vue&type=script&lang=js"
export * from "./qlk-media.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports